/**
 * PRNG local au CLIENT — jamais utilisé par la simulation.
 *
 * Convention n° 7 : `tick()` n'appelle ni `Date.now()` ni `Math.random()`. Le
 * rendu, lui, a besoin d'aléa (limaille, étoiles d'arrière-plan) : il le tire
 * d'un générateur **seedé**, donc reproductible d'une session à l'autre et
 * d'une machine à l'autre. Aucun état de jeu n'en dépend.
 */

/** PRNG minimal (mulberry32) : déterministe pour une graine donnée. */
export function createRandom(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Graine dérivée d'une chaîne (FNV-1a 32 bits) — même texte, même décor. */
export function hashSeed(text: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}
